import api from '../../lib/api'
import assign from 'lodash.assign'
import global from '../../types/global.types'

const name = 'cmcc'

export default {
  name,
  namespaced: true,
  state: {
    data: {}
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async 'data:get' ({ commit }) {
      const data = await api.data.get()
      commit('set', { data })
    },
    async init ({ dispatch }) {
      console.log('init cmcc')
      await dispatch('data:get')
    },
    async showToast ({ commit }) {
      commit(global.ERR, { message: '复制成功' }, { root: true })
    }
  }
}
